import { Component, OnInit, TemplateRef } from '@angular/core';
import { Beneficiary, Cupom, CupomBackend, CupomNovo, ProdutoSelecionado } from '../../model/cupom';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { CupomService } from '../../service/cupom/cupom.service';
import { DataService } from '../../service/data/data.service';
import { ModuloService } from 'src/app/service/modulo/modulo.service';
import { UserDetails } from '../../model/userdetails';
import { Module } from 'src/app/model/module';
import { Log } from '../../model/log';
import { InductionService } from '../../service/induction/induction.service';
import { data } from "../../model/configuration/data";
import { Field } from "../../model/configuration/Field";
import { RessarcimentoParamService } from '../../service/ressarcimentoparam/ressarcimentoparam.service';
import { Produto } from '../../model/produto';
import { Question } from '../../model/configuration/question';
import { Quiz } from '../../model/configuration/Quiz';

@Component({
  selector: 'app-cupom',
  templateUrl: './cupom.component.html',
  styleUrls: ['./cupom.component.css'],
  providers: [CupomService, InductionService]
})

export class CupomComponent implements OnInit {
  cupom: CupomNovo = new CupomNovo();
  public cupons: Cupom[] = [];
  public logs: Log[] = [];
  modalRef: BsModalRef;
  public checkboxValue: string = "1";
  public chkAtivo: number = 0;
  public chkVencido: number = 0;
  public protocoloVencido: string;
  public protocoloCancelado: string;
  public optionValue: string = "";
  public is_Protocolo: number[] = [];
  public is_Status: number[] = [];
  public exibeMsgCpf: boolean = false;
  public exibeMsgCpfGerar: boolean = false;
  public exibeMsgCelGerar: boolean = false;
  public msgValidaCpf: string = 'CPF inválido.';
  public msgValidaCel: string = 'Campo obrigatório. favor adicionar com o DDD.';
  public msgQuantidade: string;
  public incluiProtocoloModal: boolean = false;
  public static protocoloConsulta: string = '';
  public habilitaGerarCupom: boolean = true;
  private permissaoGeraCupom: boolean = false;
  public permissaoEditarEmail: boolean = false;
  public permissaoLog: boolean = false;
  public patterns: string = '[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$';
  beneficiary: any;
  public user: UserDetails;


  constructor(private modalService: BsModalService,
    private dataService: DataService,
    private cupomService: CupomService,
    private inductionService: InductionService,
    private moduloService: ModuloService) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('idUser'));
    this.permissaoLog = this.user.tp_Nivel_Master;

    this.moduloService.Get(this.user.is_Rus).subscribe((modulos: Array<Module>) => {
      if (modulos)
        this.dataService.changeModules(modulos.map(value => { return value.is_Rmd }));

      this.dataService.currentModules.subscribe(modulos => {

        if (modulos) {

          this.permissaoGeraCupom = modulos.find((value) => value == 1) != null;

          this.permissaoEditarEmail = modulos.find((value) => value == 4) != null;
        }

      });
    });
  }

  openModalRetornoPesquisa(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  onConsulta() {
    this.user = JSON.parse(localStorage.getItem('idUser'));
    var me = this;
    me.cupons = [];
    me.habilitaGerarCupom = !this.permissaoGeraCupom;
    this.dataService.currentUserDetails.subscribe(details => {
      me.cupomService.onSearchProtocolo(this.optionValue, parseInt(me.checkboxValue), details.is_Ressarcimento, this.user)
        .subscribe((res: any) => {
          this.beneficiary = res.beneficiary;
          if (res.cupons && res.cupons.length > 0) {
            this.cupons = res.cupons;
            CupomComponent.protocoloConsulta = '';
          }
          else if (res.result && res.result.length > 0) {
            this.cupons = res.result;
            CupomComponent.protocoloConsulta = '';
          }
          else {
            this.openModalRetornoConsulta();
            if (me.checkboxValue == '1')
              CupomComponent.protocoloConsulta = this.optionValue;
            else
              CupomComponent.protocoloConsulta = '';
          }

        }, error => {
        });
    }).unsubscribe();
  }

  CheckCupom() {
    this.chkAtivo = 0;
    this.chkVencido = 0;

    // Criação de um objeto de listagem filtrada
    var is_protocolo = this.is_Protocolo;

    var listaFiltrada = this.cupons.filter(function (a) {
      return is_protocolo.some(function (t) {
        return a.is_Protocolo === t;
      })
    });

    //Registra ocorrência de vencido e ocorrido    
    for (var b = 0; b < listaFiltrada.length; b++) {
      if (listaFiltrada[b].is_Status == 1) {
        this.chkAtivo++;
      }

      if (listaFiltrada[b].is_Status == 2) {
        this.chkVencido++;
      }
    }

    if (this.chkAtivo > 0 && this.chkVencido > 0) {
      this.openModalAvisoChecks();
      this.is_Protocolo = [];
      this.onConsulta();
    }
  }

  ConcatCupom(protocolo: number) {
    var protocolos: number[] = [];

    if (this.is_Protocolo.includes(protocolo)) {
      this.is_Protocolo.forEach(function (value) {
        if (value != protocolo) {
          protocolos.push(value);
        }
      });

      this.is_Protocolo = [];
      this.is_Protocolo = protocolos;
      protocolos = [];
    }
    else {
      this.is_Protocolo.push(protocolo);
    }
  }

  CancelaCupons() {
    this.protocoloCancelado = this.is_Protocolo.toString();

    this.dataService.currentUserDetails.subscribe(details => {
      this.cupomService.onCancela(this.protocoloCancelado, details.is_Rus, details.is_Ressarcimento).then((value: any) => {
        this.resetCheck();
        this.openModalRetornoCancela(value.mensagemRetorno);
        this.onConsulta();
      }, (err) => {
        alert(err);
      });
    }).unsubscribe();
  }

  ReativaCupons() {
    this.protocoloVencido = this.is_Protocolo.toString();

    this.dataService.currentUserDetails.subscribe(details => {
      this.cupomService.onReativa(this.protocoloVencido, details.is_Ressarcimento, details.is_Rus).then((value: any) => {
        this.resetCheck();
        this.openModalRetornoReativa(value.mensagemRetorno);
        this.onConsulta();
      }, (err) => {
        alert(err);
      });
    }).unsubscribe();
  }

  openModalLog(template: TemplateRef<any>, is_Ressarcimento: any, is_Protocolo: any) {
    var me = this;
    this.logs = [];

    me.cupomService.onSearchLogs(parseInt(is_Ressarcimento), parseInt(is_Protocolo))
      .subscribe((res: Array<any>) => {

        if (res.length > 0) {
          this.logs = res;
        }

        this.modalRef = this.modalService.show(template);

      }, error => {
      });
  }

  openModalGerarCupom() {
    const initialState = {
      title: 'Gerar cupom',
      message: '',
      closeBtnName: 'Fechar',
      beneficiary: this.beneficiary
    };
    this.modalRef = this.modalService.show(ModalContentGerarCupomComponent, { initialState, class: 'gray modal-lg', backdrop: 'static', keyboard: false });
    this.modalRef.content.closeBtnName = 'Close';
  }

  openModalRetornoConsulta() {
    const initialState = {
      title: 'Informação não encontrada',
      message: 'Nenhum resultado encontrado para sua pesquisa',
      closeBtnName: 'Fechar'
    };

    this.modalRef = this.modalService.show(ModalContentComponent, { initialState });
    this.modalRef.content.closeBtnName = 'Close';
  }

  openModalAvisoChecks() {
    const initialState = {
      title: 'Atenção',
      message: 'Selecione apenas cupons com o mesmo status.',
      closeBtnName: 'Fechar'
    };

    this.modalRef = this.modalService.show(ModalContentComponent, { initialState });
    this.modalRef.content.closeBtnName = 'Close';
  }

  openModalRetornoCancela(mensagem) {
    const initialState = {
      title: 'Atenção',
      message: mensagem,
      closeBtnName: 'Fechar'
    };

    this.modalRef = this.modalService.show(ModalContentComponent, { initialState });
    this.modalRef.content.closeBtnName = 'Close';
  }

  openModalEditarEmail(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  formValidateContact(email) {
    if (!(/(.+)@(.+){2,}\.(.+){2,}/.test(email)) || !this.validCel())
      return true;
    else
      return false;
  }

  validCel() {
    if (!this.cupom.beneficiario_endereco_cel || this.cupom.beneficiario_endereco_cel.length < 11) {
      this.exibeMsgCelGerar = true;
    } else {
      this.exibeMsgCelGerar = false;
    }

    return !this.exibeMsgCelGerar;
  }

  onSubmitContact() {
    this.dataService.currentUserDetails.subscribe(userDetails => {

      if (!this.validCel()) throw 'Número de celular obrigatório';

      let cupomBack: CupomBackend = new CupomBackend;

      cupomBack.is_Pln = userDetails.is_Pln;
      cupomBack.is_Ressarcimento = userDetails.is_Ressarcimento;

      this.cupomService.onEditContact(this.is_Protocolo.toString(), cupomBack.is_Ressarcimento, this.cupom.beneficiario_email_1, userDetails.is_Rus, this.cupom.beneficiario_endereco_cel).then((value: any) => {

        if (value.statusRetorno >= 1) {
          this.modalRef.hide();
          this.onConsulta();
          this.resetCheck();
          this.openModalRetorno(value.mensagemRetorno);
          this.cupom.beneficiario_email_1 = '';
        }
        else {
          this.openModalRetorno(value.mensagemRetorno);
        }

      }, (err) => {
        alert(err);
      });
    });
  }

  resetCheck() {
    this.is_Protocolo = [];
  }

  onReenvioEmail() {
    this.dataService.currentUserDetails.subscribe(userDetails => {

      this.cupomService.onReenvioEmail(this.is_Protocolo.toString(), userDetails.is_Ressarcimento, userDetails.is_Pln).then((value: any) => {

        if (value.statusRetorno >= 1) {
          this.onConsulta();
          this.resetCheck();
          this.openModalRetorno(value.mensagemRetorno);
        }
        else {
          this.openModalRetorno(value.mensagemRetorno);
        }

      }, (err) => {
        alert(err);
      });
    });
  }

  openModalRetorno(mensagem) {
    const initialState = {
      title: 'Atenção',
      message: mensagem,
      closeBtnName: 'Fechar'
    };

    this.modalRef = this.modalService.show(ModalContentComponent, { initialState });
    this.modalRef.content.closeBtnName = 'Close';
  }

  openModalRetornoReativa(mensagem) {
    const initialState = {
      title: 'Atenção',
      message: mensagem,
      closeBtnName: 'Fechar'
    };

    this.modalRef = this.modalService.show(ModalContentComponent, { initialState });
    this.modalRef.content.closeBtnName = 'Close';
  }


  validaCPF(cpf, tipo) {
    this.exibeMsgCpf = false;
    //Validação tipo 1 campo Search/ 2 - Gerar cupom    

    var numeros, digitos, soma, i, resultado, digitos_iguais;
    digitos_iguais = 1;
    if (cpf != null) {
      if (cpf.length == 11) {

        for (i = 0; i < cpf.length - 1; i++)
          if (cpf.charAt(i) != cpf.charAt(i + 1)) {
            digitos_iguais = 0;
            break;
          }
        if (!digitos_iguais) {
          numeros = cpf.substring(0, 9);
          digitos = cpf.substring(9);
          soma = 0;
          for (i = 10; i > 1; i--)
            soma += numeros.charAt(10 - i) * i;
          resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
          if (resultado != digitos.charAt(0)) {
            this.exibeMsgCpf = true;
            if (tipo == 2) {
              this.exibeMsgCpfGerar = true;
            }
            else {
              this.exibeMsgCpfGerar = false;
            }
            return false;
          }
          numeros = cpf.substring(0, 10);
          soma = 0;
          for (i = 11; i > 1; i--)
            soma += numeros.charAt(11 - i) * i;
          resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
          if (resultado != digitos.charAt(1)) {
            this.exibeMsgCpf = true;
            if (tipo == 2) {
              this.exibeMsgCpfGerar = true;
            } else {
              this.exibeMsgCpfGerar = false;
            }
            return false;
          }
          this.exibeMsgCpf = false;
          if (tipo == 2) {
            this.exibeMsgCpfGerar = false;
          }
          else {
            this.exibeMsgCpfGerar = false;
          }
          return true;
        }
        else {
          this.exibeMsgCpf = true;
          if (tipo == 2) {
            this.exibeMsgCpfGerar = true;
          }
          else {
            this.exibeMsgCpfGerar = false;
          }
          return false;
        }
      }
    }
    else {
      return true;
    }
  }
}

@Component({
  selector: 'modal-content',
  template: `
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{title}}</h4>
    </div>
    <div class="modal-body">
       <p>{{message}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">Fechar</button>
    </div>
  `
})

export class ModalContentComponent {
  title: string;
  message: any;
  closeBtnName: string;


  constructor(public bsModalRef: BsModalRef) {
  }
}

@Component({
  selector: 'modal-content',
  template: `
  <div class="modal-header">
    <div class="header-buttons">
        <h4 class="modal-title pull-left">{{title}}</h4>
        <button (click)="bsModalRef.hide()">X</button>
    </div>
  </div>
  <div *ngIf="!exibeCadastroDinamico" class="modal-body">
    <form class="light senha" (ngSubmit)="onSubmit()" #cupomForm="ngForm">
        <div class="field">
            <div class="col-lg-4 flush col-sm-4 col-xs-12">
              <label>CPF</label>
            </div>	
            <div class="col-lg-8 col-sm-8 col-xs-12">
              <input type="text"
                     name="cpf"
                     [(ngModel)]="cupom.beneficiario_cpf"
                     mask="000.000.000-99"
                     (change)="validaCPF(cupom.beneficiario_cpf, 2)"
                     required  />
              <small class="form-text text-muted" *ngIf="exibeMsgCpf && exibeMsgCpfGerar" style="color:red;">
                <strong>{{msgValidaCpf}}</strong>
              </small>
            </div>	
        </div>          
      <div class="field">
        <div class="col-lg-4 flush col-sm-4 col-xs-12">
          <label>Número de protocolo</label>
        </div>        
        <div class="col-lg-8 col-sm-8 col-xs-12" >
          <input 
          type="text" 
          name="nr_protocolo" 
          class="form-control" 
          required 
          [(ngModel)]="protocoloConsulta"
          [value]="protocoloConsulta"
          placeholder="" 
          maxlength="100"
          />
        </div>        
      </div>
      <div class="field">
        <div class="col-lg-4 flush col-sm-4 col-xs-12">
          <label>Nome do paciente</label>
        </div>	
        <div class="col-lg-8 col-sm-8 col-xs-12">
          <input type="text" 
          name="beneficiario_nome" 
          class="form-control" 
          [(ngModel)]="cupom.beneficiario_nome" 
          placeholder=""
          required />
        </div>	
      </div>
      <div class="field">
        <div class="col-lg-4 flush col-sm-4 col-xs-12">
          <label>e-mail</label>
        </div>	
        <div class="col-lg-8 col-sm-8 col-xs-12">
          <input type="text"  
          name="E-mail" 
          class="form-control" 
          [(ngModel)]="cupom.beneficiario_email_1" 
          placeholder=""           
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
          required
          />
        </div>	
      </div>
      <div class="field">
        <div class="col-lg-4 flush col-sm-4 col-xs-12">
          <label>Celular</label>
        </div>
        <div class="col-lg-8 col-sm-8 col-xs-12">
          <input type="text"
          name="Celular"
          class="form-control"
          [(ngModel)]="cupom.beneficiario_endereco_cel"
          placeholder=""
          (blur)="validCel(cupom.beneficiario_endereco_cel)"
          mask="(00)00000-0000"
          required
          />
          <small class="form-text text-muted" *ngIf="exibeMsgCelGerar" style="color:red;">
            <strong>{{msgValidaCel}}</strong>
          </small>
        </div>
      </div>
      <div class="field">
        <div class="col-lg-4 flush col-sm-4 col-xs-12">
          <label>Quantidade de cupons</label>
        </div>	
        <div class="col-lg-8 col-sm-8 col-xs-12">
          <input type="number"
                 name="qtd_cupons"
                 class="form-control"
                 [(ngModel)]="cupom.qtd_Cupons"
                 [min]="1"
                 [max]="9"
                 [step]="1"
                 [value]="cupom.qtd_Cupons"
                 (change)="validaQuantidade(cupom.qtd_Cupons)"
                 required />
          <small class="form-text text-muted" *ngIf="msgQuantidade != ''" style="color:red;">
            <strong>{{msgQuantidade}}</strong>
          </small>
        </div>

        
      </div>
      <div class="field" style="display: flex;">
        <div class="col-lg-4 normal-right col-sm-6 col-xs-12" style="margin:0 auto">          
          <button type="submit" class="btn btn-info btn-gerar" [disabled]="formValidate(protocoloConsulta)" >Gerar cupom</button>
        </div>
      </div>
    </form>    
  </div>
<div *ngIf="exibeCadastroDinamico" class="modal-body">
  <form class="light senha" (ngSubmit)="onSubmit()" #cupomFormDinamico="ngForm">
  <div class="field">
      <label class="col-lg-4">Número de protocolo</label>
      <input 
        type="text" 
        name="nr_protocolo" 
        class="col-lg-8" 
        required 
        [(ngModel)]="protocoloConsulta"
        [value]="protocoloConsulta"
        placeholder="" 
        maxlength="100"
      />
  </div>
  <div class="field">
      <label class="col-lg-4">Quantidade de cupons</label>
      <input type="number"
               name="qtd_cupons"
               class="col-lg-8"
               [(ngModel)]="cupom.qtd_Cupons"
               [min]="1"
               [max]="9"
               [step]="1"
               [value]="cupom.qtd_Cupons"
               (change)="validaQuantidade(cupom.qtd_Cupons)"
               required />
      <small class="form-text text-muted" *ngIf="msgQuantidade != ''" style="color:red;">
        <strong>{{msgQuantidade}}</strong>
      </small>

  </div>

  <ng-container *ngFor="let field of fields">
    <div *ngIf="!apiAliasHidden.includes(field.apiAlias)" [ngSwitch]="field.type" class="field">
      <label class="col-lg-4">{{field.label}}</label>
      <input class="col-lg-8"
             *ngSwitchCase="'Cep'"
             [name]="field.apiAlias"
             [required]="field.isRequiredOnCreate"
             mask="99999-999"
             [(ngModel)]="cupom.beneficiario_endereco_cep"
             
      />

      <ng-container *ngIf="field.apiAlias === 'beneficiario_cpf'">
        <input class="col-lg-8"
             [name]="field.apiAlias"
             [required]="field.isRequiredOnCreate"
             mask="999.999.999-99"
             [(ngModel)]="cupom.beneficiario_cpf"
             [disabled]="!field.isAvaiableOnCreate || beneficiarioExiste"
        />
      </ng-container>
      <ng-container *ngIf="field.apiAlias === 'beneficiario_dt_nascimento'">
        <input class="col-lg-8"
               type="date"
               *ngSwitchCase="'Data'"
               [name]="field.apiAlias"
               [required]="field.isRequiredOnCreate"
               [(ngModel)]="cupom.beneficiario_dt_nascimento"
               (change)="validaData()"
               [class.input-erro]="dataInvalida"
               
          />
        </ng-container>
      <ng-container *ngIf="field.apiAlias === 'beneficiario_endereco_uf'">
      <select class="col-lg-8"
              *ngSwitchCase="'Lista Select'"
              [(ngModel)]="cupom.beneficiario_endereco_uf"
              [name]="field.apiAlias"
              [required]="field.isRequiredOnCreate"
              
       >
        <option *ngFor="let option of field.allowedValues" [value]="option.value">{{option.label}}</option>
      </select>
      </ng-container>
      <ng-container *ngIf="field.apiAlias === 'beneficiario_pais'">
        <select class="col-lg-8"
                *ngSwitchCase="'Lista Valores Fixos'"
                [name]="field.apiAlias"
                [(ngModel)]="cupom.beneficiario_pais"
                [required]="field.isRequiredOnCreate"
                
          >
          <option *ngFor="let option of field.allowedValues" [value]="option.value">{{option.label}}</option>
        </select>
      </ng-container>
      <ng-container *ngIf="field.apiAlias === 'beneficiario_diabete'">
        <select class="col-lg-8"
                *ngSwitchCase="'Lista Valores Fixos'"
                [name]="field.apiAlias"
                [(ngModel)]="cupom.beneficiario_diabete"
                [required]="field.isRequiredOnCreate"
                
          >
          <option *ngFor="let option of field.allowedValues" [value]="option.value">{{option.label}}</option>
        </select>
      </ng-container>
      <ng-container *ngIf="field.apiAlias === 'beneficiario_tp_sexo'">
        <select class="col-lg-8"
                *ngSwitchCase="'Lista Valores Fixos'"
                [name]="field.apiAlias"
                [(ngModel)]="cupom.beneficiario_tp_sexo"
                [required]="field.isRequiredOnCreate"
                
          >
          <option *ngFor="let option of field.allowedValues" [value]="option.value">{{option.label}}</option>
        </select>
      </ng-container>
      <input class="col-lg-8"
             type="tel"
             *ngSwitchCase="'Telefone'"
             [name]="field.apiAlias"
             [required]="field.isRequiredOnCreate"
             mask="(99) 99999-9999"
             [(ngModel)]="cupom.beneficiario_endereco_cel"
             
      />
      <ng-container *ngIf="field.apiAlias === 'beneficiario_nome'">
        <input class="col-lg-8"
               *ngSwitchCase="'Texto'"
               [name]="field.apiAlias"
               [required]="field.isRequiredOnCreate"
               [(ngModel)]="cupom.beneficiario_nome"
               
        />
      </ng-container>
      <ng-container *ngIf="field.apiAlias === 'beneficiario_endereco'">
        <input class="col-lg-8"
               *ngSwitchCase="'Texto'"
               [name]="field.apiAlias"
               [required]="field.isRequiredOnCreate"
               [(ngModel)]="cupom.beneficiario_endereco"
               
        />
      </ng-container>
      <ng-container *ngIf="field.apiAlias === 'beneficiario_endereco_numero'">
        <input class="col-lg-8"
               maxlength="10"
               [name]="field.apiAlias"
               [required]="field.isRequiredOnCreate"
               [(ngModel)]="cupom.beneficiario_endereco_numero"
               
        />
      </ng-container>
      <ng-container *ngIf="field.apiAlias === 'beneficiario_endereco_complemento'">
        <input class="col-lg-8"
               *ngSwitchCase="'Texto'"
               [name]="field.apiAlias"
               [required]="field.isRequiredOnCreate"
               [(ngModel)]="cupom.beneficiario_endereco_complemento"
               
        />
      </ng-container>
      <ng-container *ngIf="field.apiAlias === 'beneficiario_endereco_bairro'">
        <input class="col-lg-8"
               *ngSwitchCase="'Texto'"
               [name]="field.apiAlias"
               [required]="field.isRequiredOnCreate"
               [(ngModel)]="cupom.beneficiario_endereco_bairro"
               
        />
      </ng-container>
      <ng-container *ngIf="field.apiAlias === 'beneficiario_endereco_cidade'">
        <input class="col-lg-8"
               *ngSwitchCase="'Texto'"
               [name]="field.apiAlias"
               [required]="field.isRequiredOnCreate"
               [(ngModel)]="cupom.beneficiario_endereco_cidade"
               
        />
      </ng-container>
      <input class="col-lg-8"
             type="email"
             *ngSwitchCase="'Email'"
             [name]="field.apiAlias"
             [required]="field.isRequiredOnCreate"
             [(ngModel)]="cupom.beneficiario_email_1"
             
      />
    </div>
  </ng-container>
  <div class="field" *ngIf="exibeProdutos">
    <label class="col-lg-4">Produtos</label>
    <ng-container>
        <ng-multiselect-dropdown
          [placeholder]="'Produtos'"
          [settings]="dropdownSettings"
          [data]="apresentacoes"
          (onSelect)="onItemSelect($event)"
          (onDeSelect)="onDeSelect($event)"
        >
      </ng-multiselect-dropdown>
    </ng-container>
  </div>

    <!--<div *ngFor="let questoes of quizQuestions">

      <div class="field-checkbox">
        <ng-container>
          <input
            id="questoes.questionAlias"
            type="checkbox"
            [name]="questoes.questionAlias"
            [required]="questoes.isRequired"
            [(ngModel)]="questoes.value"
          />
          </ng-container>
          <label for="questoes.questionAlias">{{questoes.title}}</label>
      </div>

    </div>-->
    <div *ngFor="let questoes of quizQuestions" class="field">
      <!-- Checkbox - tratamento especial sem label externo -->
      <ng-container *ngIf="questoes.questionType === 'Checkbox'">
        <div class="field-checkbox">
          <input
            type="checkbox"
            [id]="questoes.questionAlias"
            [name]="questoes.questionAlias"
            [required]="questoes.isRequired"
            [(ngModel)]="questoes.value"
          />
          <label [for]="questoes.questionAlias">{{questoes.title}}</label>
        </div>
      </ng-container>

      <!-- Outros tipos - com label externo -->
      <ng-container *ngIf="questoes.questionType !== 'Checkbox'">
        <label class="col-lg-4">{{questoes.title}}</label>

        <!-- Lista (Dropdown) -->
        <ng-container *ngIf="questoes.questionType === 'Lista'">
          <select class="col-lg-8"
                  [name]="questoes.questionAlias"
                  [required]="questoes.isRequired"
                  [(ngModel)]="questoes.value">
            <option *ngFor="let option of questoes.allowedValues" [value]="option.value">{{option.label}}</option>
          </select>
        </ng-container>

        <!-- Texto -->
        <ng-container *ngIf="questoes.questionType === 'Texto'">
          <input class="col-lg-8"
                 type="text"
                 [name]="questoes.questionAlias"
                 [required]="questoes.isRequired"
                 [(ngModel)]="questoes.value"
                 [maxlength]="questoes.maximumAnswerLength"
          />
        </ng-container>
      </ng-container>
    </div>

    <div class="field" *ngIf="exibeAceiteContato">
      <div class="field-checkbox">
        <ng-container>
         <input type="checkbox"
           id="aceite"
           [name]="exibeAceiteContato.apiAlias"
           [required]="true"
           [(ngModel)]="cupom.beneficiario_aceite_contato"
         />
        </ng-container>
        <label for="aceite">Aceito receber contato do programa via SMS ou e-mail</label>
      </div>
    </div>
<div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">Fechar</button>
    <div class="col-lg-4 normal-right col-sm-6 col-xs-12" style="margin:0 auto">          
      <button type="submit" class="btn btn-info btn-gerar" [disabled]="formValidate(protocoloConsulta)">Gerar cupom</button>
    </div>
  </div>
  </form>
</div>
  
  `,
  styles: [`
    .modal-header {
      background-color: #f5f5f5;
      border-bottom: 1px solid #ddd;
    }
    .field {
      margin-bottom: 10px;
    }
    .field label {
      display
      font-weight: bold;
      margin-bottom: 5px;
    }
    .field input, .field select {
      padding: 5px;
      width: 100%;
    }
  `]
})

export class ModalContentGerarCupomComponent {
  title: string;
  message: any;
  closeBtnName: string;
  cupom: CupomNovo = new CupomNovo();

  beneficiary: any;
  msgQuantidade: string = '';
  exibeMsgCpf: boolean = false;
  msgValidaCpf: string = 'CPF inválido.';
  msgValidaCel: string = 'Número de celular inválido, favor adicionar o DDD.';
  exibeMsgCpfGerar: boolean = false;
  exibeMsgCelGerar: boolean = false;
  exibeCadastroDinamico: boolean = false;
  modalRef: BsModalRef;
  patterns: string = '[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$';
  protocoloConsulta: string = CupomComponent.protocoloConsulta;
  fields: Field[];
  exibeAceiteContato: Field;
  quiz: Quiz[];
  quizQuestions: Question[];
  apiAliasHidden = [
    "beneficiario_dt_fim"
    , "beneficiario_data_alteracao"
    , "beneficiario_dt_inicio"
    , "beneficiario_cartao_usuario"
    , "beneficiario_cartao_titular"
    , "beneficiario_tp_cvp_gen"
  ];
  beneficiarioExiste: boolean;
  exibeProdutos: boolean;
  dropdownSettings = {
    singleSelection: false,
    enableCheckAll: false,
    idField: 'value',
    textField: 'label',
    itemsShowLimit: 2,
    allowSearchFilter: false
  };
  dataInvalida: boolean;
  apresentacoes = [];
  anoDataNascimentoMin = 1900;

  constructor(public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private cupomService: CupomService,
    private ressarcimentoParamService: RessarcimentoParamService,
    private inductionService: InductionService,
    private dataService: DataService) {
  }

  onItemSelect(item: any) {
    this.cupom.produtos.push(item);

    let produtoSelecionado = new ProdutoSelecionado();
    produtoSelecionado.label = item.label;
    produtoSelecionado.value = item.value;

    this.cupom.produtoo.push(produtoSelecionado);
  }

  onDeSelect(items: any) {
    var index = this.cupom.produtos.findIndex(x => x.value === items.value);
    this.cupom.produtos.splice(index, 1);
  }

  ngOnInit() {

    this.cupom.produtos = [];
    this.cupom.produtoo = new Array<ProdutoSelecionado>();

    let user: UserDetails = JSON.parse(localStorage.getItem('idUser'));
    this.exibeProdutos = user.exibe_Medicamento;

    this.exibeCadastroDinamico = user.utiliza_Cadastro_Dinamico;

    if (this.exibeCadastroDinamico) {
      this.inductionService.onSearchConfiguration(user).subscribe((res: data) => {
        this.fields = res.fields.sort((a, b) => a.order - b.order);

          this.quiz = res.quiz;
        this.quizQuestions = this.quiz[0].questions;

        console.log('this.quiz: ', this.quiz)

        this.exibeAceiteContato = this.fields.find(x => x.apiAlias === "beneficiario_aceite_contato");
        // existe o cpf pesquisado 
        if (this.beneficiary != null) {
          this.beneficiarioExiste = true;
          this.beneficiary.fields.forEach((ben: any) => {
            const beneficiarioEncontrado = this.fields.find(x => x.columnId == ben.columnId);

            if (beneficiarioEncontrado.apiAlias === 'beneficiario_dt_nascimento') {
              let dataParse = typeof (ben.value) == 'string' ? ben.value.split(' ')[0] : "";
              if (dataParse) {
                ben.value = dataParse.split('/').reverse().join('-');
              }
            }
              this.cupom[beneficiarioEncontrado.apiAlias] = ben.value;

          });
        } else { // nao existe o cpf pesquisado
          this.beneficiarioExiste = false;
          this.beneficiary = this.fields.map(field => ({
            alias: field.apiAlias,
            tableId: field.tableId,
            columnId: field.columnId,
            value: ''
          }));
        }
        var result = this.fields.filter(x => x.apiAlias !== 'beneficiario_aceite_contato');
        this.fields = result;
      });

      this.ressarcimentoParamService.OnSearchProduto(user.is_Ressarcimento, '').subscribe((produtos: Produto[]) => {
        let produtosSanitizados = produtos.map(prod => {
          return {
            value: prod.iS_SKU,
            label: `${prod.dsProduto} - ${prod.dsApresentacao}`
          };
        });
        this.apresentacoes = produtosSanitizados;
      });
    } else {
      this.dataInvalida = false;
      this.cupom.beneficiario_aceite_contato = true;
    }

  }


  formValidate(nr_Protocolo) {
    const exibeProdutoValido = (this.exibeProdutos && this.cupom.produtos.length > 0) || (!this.exibeProdutos);
    const emailValido = /(.+)@(.+){2,}\.(.+){2,}/.test(this.cupom.beneficiario_email_1);
    const protocoloInvalido = (nr_Protocolo == null || nr_Protocolo == '');
    const nomeBeneficiarioInvalido = (this.cupom.beneficiario_nome == null || this.cupom.beneficiario_nome == '')
    const qtdeCupoValido = (this.cupom.qtd_Cupons >= 1 && this.cupom.qtd_Cupons <= 9);
    const celValido = this.cupom.beneficiario_endereco_cel && this.cupom.beneficiario_endereco_cel.length >= 11;
    const quizRespondido = this.quizQuestions ? this.quizQuestions.every(x => x.value) : true;

    if (!emailValido || protocoloInvalido || nomeBeneficiarioInvalido || !qtdeCupoValido || !celValido || !exibeProdutoValido || this.dataInvalida || !quizRespondido)
      return true;
    else
      return false;
  }

  validaData() {
    return this.dateIsValid(this.cupom.beneficiario_dt_nascimento);
  }

  dateIsValid(dateStr: string) {
    const patternDate = /^[0-3]{1}[0-9]{1}\/[0-1]{1}[0-9]{1}\/[1-2]{1}[0-9]{3}$/;

    const dataInvertida = dateStr.split('-').reverse().join('/');
    const anoInserido = dataInvertida.split('/')[2];

    if (anoInserido) {
      const anoNumber = Number.parseInt(anoInserido);
      const anoAtual = new Date().getFullYear();

      if (anoNumber < this.anoDataNascimentoMin || anoNumber > anoAtual) {
        this.dataInvalida = true;
        return false;
      }
    }

    if (dataInvertida.match(patternDate) == null) {
      this.dataInvalida = true;
      return false;
    }

    const date = new Date(dateStr);

    const timestamp = date.getTime();

    if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
      this.dataInvalida = true;
      return false;
    }

    this.dataInvalida = false;
    return date.toISOString().startsWith(dateStr);
  }

  validaQuantidade(qtd) {
    if (qtd < 0) {
      this.msgQuantidade = 'Não é permitido quantidade negativa.';
    }
    else {
      this.msgQuantidade = '';
    }

    if (qtd > 9) {
      //this.msgQuantidade = 'Não é permitido quantidade maior que 9';
      this.cupom.qtd_Cupons = 9;
    }
  }

  validaCPF(cpf, tipo) {
    this.exibeMsgCpf = false;
    //Validação tipo 1 campo Search/ 2 - Gerar cupom    
    var numeros, digitos, soma, i, resultado, digitos_iguais;
    digitos_iguais = 1;
    if (cpf != null) {
      if (cpf.length == 11) {

        for (i = 0; i < cpf.length - 1; i++)
          if (cpf.charAt(i) != cpf.charAt(i + 1)) {
            digitos_iguais = 0;
            break;
          }
        if (!digitos_iguais) {
          numeros = cpf.substring(0, 9);
          digitos = cpf.substring(9);
          soma = 0;
          for (i = 10; i > 1; i--)
            soma += numeros.charAt(10 - i) * i;
          resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
          if (resultado != digitos.charAt(0)) {
            this.exibeMsgCpf = true;
            if (tipo == 2) {
              this.exibeMsgCpfGerar = true;
            }
            else {
              this.exibeMsgCpfGerar = false;
            }
            return false;
          }
          numeros = cpf.substring(0, 10);
          soma = 0;
          for (i = 11; i > 1; i--)
            soma += numeros.charAt(11 - i) * i;
          resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
          if (resultado != digitos.charAt(1)) {
            this.exibeMsgCpf = true;
            if (tipo == 2) {
              this.exibeMsgCpfGerar = true;
            } else {
              this.exibeMsgCpfGerar = false;
            }
            return false;
          }
          this.exibeMsgCpf = false;
          if (tipo == 2) {
            this.exibeMsgCpfGerar = false;
          }
          else {
            this.exibeMsgCpfGerar = false;
          }
          return true;
        }
        else {
          this.exibeMsgCpf = true;
          if (tipo == 2) {
            this.exibeMsgCpfGerar = true;
          }
          else {
            this.exibeMsgCpfGerar = false;
          }
          return false;
        }
      }
    }
    else {
      return true;
    }
  }

  validCel(cel) {
    if (!cel || cel.length < 11) {
      this.exibeMsgCelGerar = true;
    } else {
      this.exibeMsgCelGerar = false;
    }

    return !this.exibeMsgCelGerar;
  }

  onSubmit() {

    const idApresentacaoSelecionada = this.cupom.produtos.map(apre => apre.value).join('|');

    this.dataService.currentUserDetails.subscribe(userDetails => {

      let cupomBack: CupomBackend = new CupomBackend();

      cupomBack.is_Pln = userDetails.is_Pln;
      cupomBack.is_Ressarcimento = userDetails.is_Ressarcimento;
      cupomBack.nr_Protocolo = this.protocoloConsulta;
      cupomBack.email = this.cupom.beneficiario_email_1;
      cupomBack.cpf = this.cupom.beneficiario_cpf;
      cupomBack.nm_Cvp = this.cupom.beneficiario_nome;
      cupomBack.qtd_Cupons = this.cupom.qtd_Cupons;
      cupomBack.nr_cel = this.cupom.beneficiario_endereco_cel;
      cupomBack.is_Rus = userDetails.is_Rus;
      cupomBack.idsProdutos = idApresentacaoSelecionada;
      cupomBack.produtos = this.cupom.produtoo;

      // Obter CRM e UF do quiz
      let crmQuestion = null;
      let ufQuestion = null;
      
      if (this.quizQuestions) {
        crmQuestion = this.quizQuestions.filter(q => q.questionAlias.startsWith('Question_Prescriber_CRM'));
        ufQuestion = this.quizQuestions.filter(q => q.questionAlias.startsWith('Question_Prescriber_State'));
      }
      
      cupomBack.nr_crm = crmQuestion ? crmQuestion.value : '';
      cupomBack.uf_crm = ufQuestion ? ufQuestion.value : '';

      if (!this.beneficiarioExiste && userDetails.utiliza_Cadastro_Dinamico)
        this.salvarBeneficiario(userDetails.param_is_pln).then(() => this.salvarCupom(cupomBack));
      else
        this.salvarCupom(cupomBack);

    }, (err) => {
      alert(err);
    });
  }

  salvarCupom(cupomBack: CupomBackend) {
    this.cupomService.onCreateCupom(cupomBack).then((value: any) => {

      if (value.statusRetorno >= 1) {
        this.bsModalRef.hide();
        this.openModalRetornoGerarCupom(value.mensagemRetorno);
      }
      else {
        this.openModalRetornoGerarCupom(value.mensagemRetorno);
      }
    }, (err) => {
      alert(err);
    });
  }

  salvarBeneficiario(is_pln) {
    this.beneficiary.forEach(ben => {
      let cupomValor = this.cupom[ben.alias];

      if (ben.alias == 'beneficiario_aceite_contato')
        cupomValor = cupomValor ? '7' : '0';

      else if (ben.alias == 'beneficiario_cartao_usuario' || ben.alias == 'beneficiario_cartao_titular')
        cupomValor = this.cupom.beneficiario_cpf;

      else if (ben.alias == 'beneficiario_dt_inicio')
        cupomValor = new Intl.DateTimeFormat('pt-BR').format(new Date());

      else if (ben.alias == 'beneficiario_dt_nascimento')
        cupomValor = this.formatarData(this.cupom.beneficiario_dt_nascimento);

      ben.value = cupomValor;
    });

    const request: Beneficiary = {
      Fields: this.beneficiary,
      Quiz: this.quiz
    };

    return this.cupomService.onRegisterInduction(request, is_pln.toString());
  }

  openModalRetornoGerarCupom(mensagem) {
    const initialState = {
      title: 'Atenção',
      message: mensagem,
      closeBtnName: 'Fechar'
    };

    this.modalRef = this.modalService.show(ModalContentComponent, { initialState });
    this.modalRef.content.closeBtnName = 'Close';
  }


  formatarData(data: string) {
    const dataSplited = data.split('-').reverse(); // 1999-02-02

    const dia = Number(dataSplited[0]);
    const mes = Number(dataSplited[1]) - 1; // indice do mes começa com 0, 0 = janeiro, 1 = fevereiro, 2 = março ...
    const ano = Number(dataSplited[2]);

    const novaDta = new Date(ano, mes, dia, 12, 0, 0, 0);

    return new Intl.DateTimeFormat('pt-BR').format(novaDta);
  }
}
